// extracted by mini-css-extract-plugin
export default {"inner":"rXEdUMb6"};